import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * UAE Emirates ID validator following Single Responsibility Principle
 */
export class ArValidator extends BaseValidator {
  constructor() {
    super({
      name: 'UAE Emirates ID',
      pattern: /^784-\d{4}-\d{7}-\d$/,
      length: 18
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'UAE Emirates ID format must be 784-XXXX-XXXXXXX-X'
    );
  }

  validateChecksum(id) {
    const digits = id.replace(/-/g, '').substring(3); // Remove country code and dashes
    
    // Luhn algorithm on the remaining digits
    let sum = 0;
    let alternate = false;

    for (let i = digits.length - 2; i >= 0; i--) {
      let n = parseInt(digits[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const expectedChecksum = (10 - (sum % 10)) % 10;
    const actualChecksum = parseInt(digits[digits.length - 1]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid UAE Emirates ID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid UAE Emirates ID');
  }
}